import { defaultProfileColumnsConfig } from 'UI/constants/defaults';

export const notesColumns = [
  {
    name: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'default'
    }
  },
  {
    name: 'user.personalInformation.full_name',
    label: 'Created by',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'default'
    }
  },
  {
    name: 'body',
    label: 'Description',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'html'
    }
  },
  {
    name: 'created_at',
    label: 'Creation Date',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'date'
    }
  },
  {
    name: 'updated_at',
    label: 'Last Updated',
    options: {
      display: true,
      renderer: 'date'
    }
  }
];
